<script lang="ts">
    import { Col } from "sveltestrap";
    import data from "../../../../Data/ComponentData/Ui-kits/Typography/Headings.json";
    import { Orderlist } from "../../../../utils/Constant/Constant";
</script>

<Col sm="12" xl="4">
    <h6 class="sub-title">{Orderlist}</h6>
    <dl>
        {#each data.order as fontItem}
            <dt>{fontItem.discription}</dt>
            <dd>{fontItem.subdiscription}</dd>
        {/each}
    </dl>
</Col>
